import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    notification: {}, // 通知
};

export const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        setNotification: (state, action) => {
            state.notification = action.payload;
        },
        clearNotification: (state) => {
            state.notification = null;
        },
        setNewNotification: (state, action) => {
            state.notification.records.unshift(action.payload);
            state.notification.unreadCnt += 1;
        },
    },
});

export const notificationState = (state) => state.notification;

export const { setNotification, setNewNotification, clearNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
